// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/browser/components/SortIcon.scss
// module id = 1175
// module chunks = 0